var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c("template", { slot: "header" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "margin-right": "20px",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: { "font-size": "14px", "line-height": "35px" },
                  },
                  [_vm._v("共同被保险人")]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: { effect: "light", placement: "top" },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticStyle: { "white-space": "pre-line" } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t同一人通过亲属实际控制多个网点、网点间 代结、上下级网点关系，如有上述共同被保 险企业应在投保时列明\n\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-plus", type: "primary" },
                        on: { click: _vm.onAddUnits },
                      },
                      [_vm._v("增加共同被保险人")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              data: _vm.insuredData,
              option: _vm.optionInsured,
              "table-loading": _vm.tableLoading,
            },
            on: {
              "row-del": _vm.onRowDel,
              "cell-mouse-leave": _vm.onCellMouseLeave,
            },
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.isShowAddDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isShowAddDialog = $event
            },
          },
        },
        [
          _c("unit-common-form", {
            ref: "unitForm",
            attrs: { productId: _vm.productId, "unit-type": "3" },
            on: { onCheckSuccess: _vm.onCheckSuccess },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }